module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('swiper', {
    ref: "mySwiper",
    staticClass: "swiperContainer",
    attrs: {
      "options": _vm.swiperOption
    },
    nativeOn: {
      "click": function($event) {
        _vm.close($event)
      }
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('div', {
      staticClass: "swiper-zoom-container"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.urlOriginal || item.url),
        expression: "item.urlOriginal || item.url"
      }],
      attrs: {
        "lazy": "loading",
        "alt": ""
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    slot: "pagination"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90434ce4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/swiper/swiper.vue
// module id = 327
// module chunks = 1